import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import EmptyState404Img from '../../../../../common/assets/images/emptystates/404.svg';
import EmptyStateCardNoTransactionsImg from '../../../../../common/assets/images/emptystates/es-card-no-transcations.svg';
import EmptyStateMyCardsNoCardAddedImg from '../../../../../common/assets/images/emptystates/es-cards-no-card.svg';
import EmptyStateMyCardsImg from '../../../../../common/assets/images/emptystates/es-cards.svg';
import EmptyStateEmptyCartImg from '../../../../../common/assets/images/emptystates/es-empty-cart.svg';
import EmptyStateDashboardMyExpensesImg from '../../../../../common/assets/images/emptystates/es-expenses.svg';
import EmptyStateFavoritesImg from '../../../../../common/assets/images/emptystates/es-favorites.svg';
import EmptyStateNotificationsImg from '../../../../../common/assets/images/emptystates/es-notifications.svg';
import EmptyStateOrderSuccessImg from '../../../../../common/assets/images/emptystates/es-order-success.svg';
import EmptyStateOrdersImg from '../../../../../common/assets/images/emptystates/es-orders.svg';
import EmptyStateSubscriptionsImg from '../../../../../common/assets/images/emptystates/es-subscriptions.svg';
import EmptyStateVouchersImg from '../../../../../common/assets/images/emptystates/es-vouchers.svg';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { useContext } from 'react';

export function EmptyStateOrdersHistory() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);
  const canAccessFlexibleBenefits = customerInfo?.canAccessFlexibleBenefits;
  const to = canAccessFlexibleBenefits ? "/flexible-benefits" : "/club-benefits";

  return (
    <div className="empty-state">
      <div className="es-image">
        <img src={EmptyStateOrdersImg} alt="No orders illustration" />
      </div>
      <h3>{translate(resources.emptyState.orderHistory.title)}</h3>
      <p>{translate(resources.emptyState.orderHistory.text)}</p>
      <div className="es-cta">
        <Link to={to} className="btn btn-solid btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.orderHistory.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateBudgetTransactions() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state">
      <div className="es-image">
        <img
          src={EmptyStateOrdersImg}
          alt="No budget transactions illustration"
        />
      </div>
      <h3>{translate(resources.emptyState.budgetTransactions.title)}</h3>
      <p>{translate(resources.emptyState.budgetTransactions.text)}</p>
    </div>
  );
}

export function EmptyStateNotifications() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state">
      <div className="es-image">
        <img src={EmptyStateNotificationsImg} alt="No messages illustration" />
      </div>
      <h3>{translate(resources.emptyState.notifications.title)}</h3>
    </div>
  );
}

export function EmptyStateSubscriptions() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state">
      <div className="es-image">
        <img
          src={EmptyStateSubscriptionsImg}
          alt="No subscriptions illustration"
        />
      </div>
      <h3>{translate(resources.emptyState.subscriptions.title)}</h3>
      <p>{translate(resources.emptyState.subscriptions.text)}</p>
    </div>
  );
}

export function EmptyStateFavorites() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);
  const canAccessFlexibleBenefits = customerInfo?.canAccessFlexibleBenefits;
  const to = canAccessFlexibleBenefits ? "/flexible-benefits" : "/club-benefits";
  
  return (
    <div className="empty-state">
      <div className="es-image">
        <img src={EmptyStateFavoritesImg} alt="No favorites illustration" />
      </div>
      <h3>{translate(resources.emptyState.favorites.title)}</h3>
      <p>{translate(resources.emptyState.favorites.text)}</p>
      <div className="es-cta">
        <Link to={to} className="btn btn-solid btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.favorites.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateVouchers() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);
  const canAccessFlexibleBenefits = customerInfo?.canAccessFlexibleBenefits;
  const to = canAccessFlexibleBenefits ? "/flexible-benefits" : "/club-benefits";

  return (
    <div className="empty-state">
      <div className="es-image">
        <img src={EmptyStateVouchersImg} alt="No vouchers illustration" />
      </div>
      <h3>{translate(resources.emptyState.myVouchers.title)}</h3>
      <p>{translate(resources.emptyState.myVouchers.text)}</p>
      <div className="es-cta">
        <Link to={to} className="btn btn-solid btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.myVouchers.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateMyCards() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state">
      <div className="es-image">
        <img src={EmptyStateMyCardsImg} alt="No cards illustration" />
      </div>
      <h3>{translate(resources.emptyState.myCards.title)}</h3>
      <p>{translate(resources.emptyState.myCards.text)}</p>
    </div>
  );
}

export function EmptyStateMyCardsNoCardAdded() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state">
      <div className="es-image">
        <img
          src={EmptyStateMyCardsNoCardAddedImg}
          alt="No cards illustration"
        />
      </div>
      <h3>{translate(resources.emptyState.myCardsNoCardAdded.title)}</h3>
      <p>{translate(resources.emptyState.myCardsNoCardAdded.text)}</p>
    </div>
  );
}

export function EmptyStateMyCardNoTranscations() {
  const { t: translate } = useTranslation();

  return (
    <div className="empty-state">
      <div className="es-image">
        <img
          src={EmptyStateCardNoTransactionsImg}
          alt="No transactions illustration"
        />
      </div>
      <h3>{translate(resources.emptyState.card.title)}</h3>
      <p>{translate(resources.emptyState.card.text)}</p>
      <div className="es-cta">
        <Link to="/my-account/cards" className="btn btn-solid btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.card.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateEmptyCart() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);
  const canAccessFlexibleBenefits = customerInfo?.canAccessFlexibleBenefits;
  const to = canAccessFlexibleBenefits ? "/flexible-benefits" : "/club-benefits";
  

  return (
    <div className="empty-state es-order-page">
      <div className="es-image">
        <img src={EmptyStateEmptyCartImg} alt="Empty cart illustration" />
      </div>
      <h3>{translate(resources.emptyState.emptyCart.title)}</h3>
      <p>{translate(resources.emptyState.emptyCart.text)}</p>
      <div className="es-cta">
        <Link to={to} className="btn btn-outline btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.emptyCart.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateEmptyHeaderCart() {
  const { t: translate } = useTranslation();

  return (
    <div className="empty-state es-empty-header-cart">
      <div className="es-image">
        <img src={EmptyStateEmptyCartImg} alt="Empty cart illustration" />
      </div>
      <p>{translate(resources.emptyState.emptyHeaderCart.text)}</p>
      <div className="es-cta">
        <Link to="/cart" className="btn btn-outline btn-full btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.emptyHeaderCart.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateOrderSuccess() {
  const { t: translate } = useTranslation();

  return (
    <div className="empty-state es-order-page">
      <div className="es-image">
        <img
          src={EmptyStateOrderSuccessImg}
          alt="Order successful illustration"
        />
      </div>
      <h3>{translate(resources.emptyState.orderSuccess.title)}</h3>
      <p>
        <span>{translate(resources.emptyState.orderSuccess.orderText)} </span>
        <Link to="/my-account/orders" draggable={false}>
          <strong>
            {translate(resources.emptyState.orderSuccess.orderLink)}
          </strong>
        </Link>
        {'. '}
      </p>
      <p>
        <span
          dangerouslySetInnerHTML={{
            __html: translate(resources.emptyState.orderSuccess.voucherText),
          }}
        />{' '}
        <Link to="/my-account/vouchers" draggable={false}>
          <strong>
            {translate(resources.emptyState.orderSuccess.voucherLink)}
          </strong>
        </Link>
        .
      </p>
      <div className="es-cta">
        <Link to="/" className="btn btn-outline btn-es">
          <span className="btn-text">
            {translate(resources.emptyState.orderSuccess.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyState404() {
  const { t: translate } = useTranslation();

  return (
    <div className="empty-state es-404-page">
      <div className="es-image">
        <img src={EmptyState404Img} alt="Page not found illustration" />
      </div>
      <h3>{translate(resources.emptyState.notFoundPage.title)}</h3>
      <p>
        {translate(resources.emptyState.notFoundPage.text)}{' '}
        <Link to={translate(resources.emptyState.notFoundPage.link)}>
          {translate(resources.emptyState.notFoundPage.linkLabel)}
        </Link>
      </p>
      <div className="es-cta">
        <Link to="/" className="btn btn-solid btn-lg">
          <span className="btn-text">
            {translate(resources.emptyState.notFoundPage.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateProductNotFound() {
  const { t: translate } = useTranslation();

  return (
    <div className="empty-state es-product-not-found">
      <div className="es-image">
        <img src={EmptyState404Img} alt="Product not found illustration" />
      </div>
      <h3>{translate(resources.products.notFound)}</h3>
      <div className="es-cta">
        <Link to="/" className="btn btn-solid btn-lg">
          <span className="btn-text">
            {translate(resources.emptyState.notFoundPage.action)}
          </span>
        </Link>
      </div>
    </div>
  );
}

export function EmptyStateDashboardMyCards() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-top">
      <div className="es-image">
        <img src={EmptyStateMyCardsImg} alt="No cards illustration" />
      </div>
      <p>{translate(resources.emptyState.dashboard.myCards)}</p>
    </div>
  );
}

export function EmptyStateDashboardMyExpenses() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-top">
      <div className="es-image">
        <img
          src={EmptyStateDashboardMyExpensesImg}
          alt="No cards illustration"
        />
      </div>
      <p>{translate(resources.emptyState.dashboard.expensesStatistics)}</p>
    </div>
  );
}

export function EmptyStateDashboardMyOrders() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-bottom">
      <div className="es-image">
        <Icons.InfoDashboard />
      </div>
      <p>{translate(resources.emptyState.dashboard.orderHistory)}</p>
    </div>
  );
}

export function EmptyStateDashboardBudgetTransactions() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-bottom">
      <div className="es-image">
        <Icons.InfoDashboard />
      </div>
      <p>{translate(resources.emptyState.dashboard.budgetTransactions)}</p>
    </div>
  );
}

export function EmptyStateDashboardMySubscriptions() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-bottom">
      <div className="es-image">
        <Icons.InfoDashboard />
      </div>
      <p>{translate(resources.emptyState.dashboard.mySubscriptions)}</p>
    </div>
  );
}

export function EmptyStateAdminDashboardBudgetTimeline() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-top">
      <div className="es-image">
        <img
          src={EmptyStateDashboardMyExpensesImg}
          alt="No budget history illustration"
        />
      </div>
      <p>{translate(resources.emptyState.adminDashboard.budgetTimeline)}</p>
    </div>
  );
}

export function EmptyStateAdminDashboardOrdersTimeline() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-top">
      <div className="es-image">
        <img
          src={EmptyStateDashboardMyExpensesImg}
          alt="No order history illustration"
        />
      </div>
      <p>{translate(resources.emptyState.adminDashboard.ordersTimeline)}</p>
    </div>
  );
}

export function EmptyStateAdminDashboardPopularBenefits() {
  const { t: translate } = useTranslation();
  return (
    <div className="empty-state es-dashboard es-dashboard-top">
      <div className="es-image">
        <img
          src={EmptyStateDashboardMyExpensesImg}
          alt="No popular benefits illustration"
        />
      </div>
      <p>{translate(resources.emptyState.adminDashboard.popularBenefits)}</p>
    </div>
  );
}
